import FieldSet from '../../FieldSet';

import { CommentsCount } from './CommentsCount';

export class CommentsFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [CommentsCount];
  }

  get title() {
    return 'Comments';
  }
}
